import pageScrollTo from "./pageScrollTo";

/**
 * @name scrollToElement
 * @function
 * function to do smooth scrolling to element, with a top padding
 *
 * @param {Element} targetElement target element to scroll to
 * @param {Number} padAmount top padding of location to scroll to, from 0 - 100
 */
const scrollToElement = (targetElement, padAmount = 7) => {
  const elementOffset = getElementOffset(targetElement).top;
  const amount = elementOffset - elementOffset * padAmount / 100;

  pageScrollTo(amount, 1000);
};

/**
 * @name getWindowScroll
 * @function
 * helper function to get window scroll position
 *
 * @returns {Object} x and y scroll position of the window
 */
const getWindowScroll = () => {
  const supportPageOffset = window.pageXOffset !== undefined;
  const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

  const x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  const y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

  return {
    x: x, y: y
  };
};


/**
 * @name getElementOffset
 * @function
 * helper funciton to get element scroll position
 *
 * @param {Element} el element as reference
 */
const getElementOffset = (el) => {
  const rect = el.getBoundingClientRect();
  const windowScroll = getWindowScroll();

  return {
    top: rect.top + windowScroll.y, left: rect.left + windowScroll.x
  };
};

export default scrollToElement;

